<template>
  <nav class="gnb">
    <ul>
      <li v-for="(item, idx) in mData" :key="idx"  >
        <button type="button" @click="toggleMenu (item, $event)" ref="mainList" :class="{'on':item.path === this.getNowPath && !(!!item.sub)}" >
          <span class="gnb_ico" :class="item.icon"></span>
          {{ $t(`${item.text}`) }}
          <span v-if="item.sub" class="arrow_ico" :class="item.open ? 'on' : ''"></span>
        </button>
        <ul v-if="item.open">
          <li v-for="(subMenu,index) in item.sub" :key="subMenu.id" ref="subList"  :class="{'on': item.open && (index === getActiveIdx) && getNowPath === subMenu.path }"  @click="toggleSubMenu($event, item, subMenu.path)">
            <router-link :to="subMenu.path" >
              {{ $t(`${subMenu.text}`) }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import menuData from '@/assets/menu.json'
import { mapGetters, mapMutations } from 'vuex'

export default {
  emits: [],
  data () {
    return {
      mData: menuData.data,
      nowRouter: '',
      menu: this.$router.options.routes,
      isActive: false,
      activeSubIdx: this.setActiveIdx
    }
  },
  computed: {
    ...mapGetters([
      'getPageNum',
      'getNowPath',
      'getActiveIdx'
    ])
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        const totalLength = this.mData.length
        for (let i = 0; i < totalLength; i++) {
          this.$refs.mainList[i].classList.value = ''
          if (this.mData[i].path === this.getNowPath) {
            this.$refs.mainList[i].classList.value = 'on'
          }
          if (this.mData[i].sub) {
            const subLength = this.mData[i].sub.length
            for (let j = 0; j < subLength; j++) {
              if (this.mData[i].sub[j].path === this.getNowPath) {
                this.mData[i].open = true
                this.setActiveIdx(j)
              }
            }
          }
        }
      }
    }
  },
  created () {
    this.nowRouter = this.$route.matched[0].path
  },
  mounted () {
    this.setNowPath(this.nowRouter)
    this.checkRouter(this.nowRouter, this.addActive)
  },
  methods: {
    ...mapMutations([
      'setPageNum',
      'setNowPath',
      'setActiveIdx'
    ]),
    checkLast () {
      this.lastNext = this.getPageNum === this.menu.length - 1
      this.lastPrev = this.getPageNum === 0
    },
    toggleMenu (item, event) {
      if (item.path) this.setNowPath(item.path)
      const target = event.target
      this.menu.forEach((el, index) => {
        if (el.path === item.path) {
          this.setPageNum(index)
          this.checkLast()
          this.$router.push(item.path)
        }
      })
      if (!item.sub) {
        this.removeAddClass()
        target.classList.add('on')
      }
      item.open = !item.open
    },
    addActive (item) {
      item.open = true
      item?.sub.forEach((subItem, index) => {
        if (subItem.path === this.getNowPath) {
          this.setActiveIdx(index)
        }
      })
    },
    toggleSubMenu (event, item, path) {
      this.setNowPath(path)
      const target = event.target
      const subLength = item.sub.length
      for (let i = 0; i < subLength; i++) {
        if (item.sub[i].path === this.getNowPath) {
          this.setPageNum(item.sub[i].pageNum)
          item.open = true
          this.setActiveIdx(i)
        }
      }
      this.removeAddClass()
      target.parentNode.classList.add('on')
    },
    removeAddClass () {
      const buttonLength = this.$refs.mainList.length
      const subButtonLength = this.$refs.subList?.length
      for (let i = 0; i < buttonLength; i++) {
        this.$refs.mainList[i].classList.value = ''
      }
      for (let i = 0; i < subButtonLength; i++) {
        this.$refs.subList[i].classList.value = ''
      }
    },
    checkRouter (router, callBack) {
      this.menu.forEach((element) => {
        if (element.path === router) {
          this.mData.forEach((item) => {
            const length = item?.sub?.length
            for (let i = 0; i < length; i++) {
              if (item.sub[i].path === router) {
                callBack(item)
              }
            }
          })
        }
      })
    }
  }
}
</script>
